var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22.75 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31 13.245a3.468 3.468 0 01-1.81.505 3.502 3.502 0 01-3.5-3.5c0-1.932 1.569-3.5 3.5-3.5a3.503 3.503 0 012.627 5.813M20.06 13.245a3.468 3.468 0 01-1.81.505 3.502 3.502 0 01-3.5-3.5c0-1.932 1.569-3.5 3.5-3.5a3.503 3.503 0 012.627 5.813M13.251 6.332a2.523 2.523 0 01-2.722.512 2.497 2.497 0 01-1.113-.916A2.463 2.463 0 019 4.555a2.458 2.458 0 01.719-1.777A2.501 2.501 0 0111.5 2.04a2.52 2.52 0 011.781.74A2.474 2.474 0 0114 4.554c0 .28-.048.558-.14.823M13.914 14.842c.058.21.087.427.086.644a2.455 2.455 0 01-.719 1.775A2.5 2.5 0 0111.5 18a2.522 2.522 0 01-1.781-.739A2.473 2.473 0 019 15.486c0-.28.048-.558.14-.823a2.5 2.5 0 011.732-1.583 2.516 2.516 0 012.403.653c.308.308.528.69.64 1.11z",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.416 5.928c.07.105.147.203.231.296l-2.27 2.27a3.52 3.52 0 00-1.099-1.023l2.729-2.728c.031.422.172.83.409 1.185zm5.95 2.252l-2.011-2.01.504-.792c.078-.222.124-.454.137-.689l2.591 2.592c-.47.208-.887.517-1.222.9zm-2.005 5.643c.263.291.453.64.553 1.02.042.153.069.31.08.47l1.977-1.978a3.522 3.522 0 01-1.009-1.113l-1.6 1.601zm-4.35 1.438a2.485 2.485 0 01.657-1.464L7.722 11.85a3.51 3.51 0 01-.596.946l-.315.264 2.2 2.2z",
    fill: "#242424"
  })));
}

export default SvgWhIcon;